import { render, staticRenderFns } from "./ManualHome.vue?vue&type=template&id=2dcc1dc6"
import script from "./ManualHome.vue?vue&type=script&lang=js"
export * from "./ManualHome.vue?vue&type=script&lang=js"
import style0 from "./ManualHome.vue?vue&type=style&index=0&id=2dcc1dc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports